import * as React from "react";

type UpdateState = {
  updateAvailable: boolean;
  applyUpdate: () => void;
};

export function useAdminServiceWorker(): UpdateState {
  const [updateAvailable, setUpdateAvailable] = React.useState(false);
  const regRef = React.useRef<ServiceWorkerRegistration | null>(null);

  React.useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    // ΜΟΝΟ admin: registration scope
    navigator.serviceWorker
      .register("/admin-sw.js", { scope: "/el/admin/" })
      .then((reg) => {
        regRef.current = reg;

        // Αν υπάρχει ήδη waiting worker => update available
        if (reg.waiting) setUpdateAvailable(true);

        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;

          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed") {
              // Αν υπήρχε ήδη controller => είναι update
              if (navigator.serviceWorker.controller) {
                setUpdateAvailable(true);
              }
            }
          });
        });
      })
      .catch(() => null);
  }, []);

  const applyUpdate = React.useCallback(() => {
    const reg = regRef.current;
    if (!reg?.waiting) {
      // fallback: απλό refresh
      window.location.reload();
      return;
    }

    // πες στο SW να κάνει skipWaiting
    reg.waiting.postMessage({ type: "SKIP_WAITING" });

    // όταν ενεργοποιηθεί, κάνε reload
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });
  }, []);

  return { updateAvailable, applyUpdate };
}
